/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiOcppOperationGetStatusNotificationForModuleGet$Json } from '../fn/ocpp-operation/api-ocpp-operation-get-status-notification-for-module-get-json';
import { ApiOcppOperationGetStatusNotificationForModuleGet$Json$Params } from '../fn/ocpp-operation/api-ocpp-operation-get-status-notification-for-module-get-json';
import { apiOcppOperationGetStatusNotificationForModuleGet$Plain } from '../fn/ocpp-operation/api-ocpp-operation-get-status-notification-for-module-get-plain';
import { ApiOcppOperationGetStatusNotificationForModuleGet$Plain$Params } from '../fn/ocpp-operation/api-ocpp-operation-get-status-notification-for-module-get-plain';
import { apiOcppOperationMeterValuesPost$Json } from '../fn/ocpp-operation/api-ocpp-operation-meter-values-post-json';
import { ApiOcppOperationMeterValuesPost$Json$Params } from '../fn/ocpp-operation/api-ocpp-operation-meter-values-post-json';
import { apiOcppOperationMeterValuesPost$Plain } from '../fn/ocpp-operation/api-ocpp-operation-meter-values-post-plain';
import { ApiOcppOperationMeterValuesPost$Plain$Params } from '../fn/ocpp-operation/api-ocpp-operation-meter-values-post-plain';
import { apiOcppOperationRemoteStartTransactionPost } from '../fn/ocpp-operation/api-ocpp-operation-remote-start-transaction-post';
import { ApiOcppOperationRemoteStartTransactionPost$Params } from '../fn/ocpp-operation/api-ocpp-operation-remote-start-transaction-post';
import { apiOcppOperationRemoteStopTransactionPost } from '../fn/ocpp-operation/api-ocpp-operation-remote-stop-transaction-post';
import { ApiOcppOperationRemoteStopTransactionPost$Params } from '../fn/ocpp-operation/api-ocpp-operation-remote-stop-transaction-post';
import { apiOcppOperationSetMacAddressAndCarManufacturerPost } from '../fn/ocpp-operation/api-ocpp-operation-set-mac-address-and-car-manufacturer-post';
import { ApiOcppOperationSetMacAddressAndCarManufacturerPost$Params } from '../fn/ocpp-operation/api-ocpp-operation-set-mac-address-and-car-manufacturer-post';
import { apiOcppOperationStatusNotificationPost$Json } from '../fn/ocpp-operation/api-ocpp-operation-status-notification-post-json';
import { ApiOcppOperationStatusNotificationPost$Json$Params } from '../fn/ocpp-operation/api-ocpp-operation-status-notification-post-json';
import { apiOcppOperationStatusNotificationPost$Plain } from '../fn/ocpp-operation/api-ocpp-operation-status-notification-post-plain';
import { ApiOcppOperationStatusNotificationPost$Plain$Params } from '../fn/ocpp-operation/api-ocpp-operation-status-notification-post-plain';
import { StatusNotificationCommand } from '../models/status-notification-command';

@Injectable({ providedIn: 'root' })
export class OcppOperationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiOcppOperationStatusNotificationPost()` */
  static readonly ApiOcppOperationStatusNotificationPostPath = '/api/OcppOperation/statusNotification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOcppOperationStatusNotificationPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationStatusNotificationPost$Plain$Response(params?: ApiOcppOperationStatusNotificationPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StatusNotificationCommand>>> {
    return apiOcppOperationStatusNotificationPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOcppOperationStatusNotificationPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationStatusNotificationPost$Plain(params?: ApiOcppOperationStatusNotificationPost$Plain$Params, context?: HttpContext): Observable<Array<StatusNotificationCommand>> {
    return this.apiOcppOperationStatusNotificationPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<StatusNotificationCommand>>): Array<StatusNotificationCommand> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOcppOperationStatusNotificationPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationStatusNotificationPost$Json$Response(params?: ApiOcppOperationStatusNotificationPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StatusNotificationCommand>>> {
    return apiOcppOperationStatusNotificationPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOcppOperationStatusNotificationPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationStatusNotificationPost$Json(params?: ApiOcppOperationStatusNotificationPost$Json$Params, context?: HttpContext): Observable<Array<StatusNotificationCommand>> {
    return this.apiOcppOperationStatusNotificationPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<StatusNotificationCommand>>): Array<StatusNotificationCommand> => r.body)
    );
  }

  /** Path part for operation `apiOcppOperationMeterValuesPost()` */
  static readonly ApiOcppOperationMeterValuesPostPath = '/api/OcppOperation/meterValues';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOcppOperationMeterValuesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationMeterValuesPost$Plain$Response(params?: ApiOcppOperationMeterValuesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return apiOcppOperationMeterValuesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOcppOperationMeterValuesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationMeterValuesPost$Plain(params?: ApiOcppOperationMeterValuesPost$Plain$Params, context?: HttpContext): Observable<number> {
    return this.apiOcppOperationMeterValuesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOcppOperationMeterValuesPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationMeterValuesPost$Json$Response(params?: ApiOcppOperationMeterValuesPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return apiOcppOperationMeterValuesPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOcppOperationMeterValuesPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationMeterValuesPost$Json(params?: ApiOcppOperationMeterValuesPost$Json$Params, context?: HttpContext): Observable<number> {
    return this.apiOcppOperationMeterValuesPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `apiOcppOperationRemoteStartTransactionPost()` */
  static readonly ApiOcppOperationRemoteStartTransactionPostPath = '/api/OcppOperation/remoteStartTransaction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOcppOperationRemoteStartTransactionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationRemoteStartTransactionPost$Response(params?: ApiOcppOperationRemoteStartTransactionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiOcppOperationRemoteStartTransactionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOcppOperationRemoteStartTransactionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationRemoteStartTransactionPost(params?: ApiOcppOperationRemoteStartTransactionPost$Params, context?: HttpContext): Observable<void> {
    return this.apiOcppOperationRemoteStartTransactionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiOcppOperationRemoteStopTransactionPost()` */
  static readonly ApiOcppOperationRemoteStopTransactionPostPath = '/api/OcppOperation/remoteStopTransaction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOcppOperationRemoteStopTransactionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationRemoteStopTransactionPost$Response(params?: ApiOcppOperationRemoteStopTransactionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiOcppOperationRemoteStopTransactionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOcppOperationRemoteStopTransactionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationRemoteStopTransactionPost(params?: ApiOcppOperationRemoteStopTransactionPost$Params, context?: HttpContext): Observable<void> {
    return this.apiOcppOperationRemoteStopTransactionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiOcppOperationGetStatusNotificationForModuleGet()` */
  static readonly ApiOcppOperationGetStatusNotificationForModuleGetPath = '/api/OcppOperation/GetStatusNotificationForModule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOcppOperationGetStatusNotificationForModuleGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOcppOperationGetStatusNotificationForModuleGet$Plain$Response(params?: ApiOcppOperationGetStatusNotificationForModuleGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StatusNotificationCommand>> {
    return apiOcppOperationGetStatusNotificationForModuleGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOcppOperationGetStatusNotificationForModuleGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOcppOperationGetStatusNotificationForModuleGet$Plain(params?: ApiOcppOperationGetStatusNotificationForModuleGet$Plain$Params, context?: HttpContext): Observable<StatusNotificationCommand> {
    return this.apiOcppOperationGetStatusNotificationForModuleGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatusNotificationCommand>): StatusNotificationCommand => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOcppOperationGetStatusNotificationForModuleGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOcppOperationGetStatusNotificationForModuleGet$Json$Response(params?: ApiOcppOperationGetStatusNotificationForModuleGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StatusNotificationCommand>> {
    return apiOcppOperationGetStatusNotificationForModuleGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOcppOperationGetStatusNotificationForModuleGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOcppOperationGetStatusNotificationForModuleGet$Json(params?: ApiOcppOperationGetStatusNotificationForModuleGet$Json$Params, context?: HttpContext): Observable<StatusNotificationCommand> {
    return this.apiOcppOperationGetStatusNotificationForModuleGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatusNotificationCommand>): StatusNotificationCommand => r.body)
    );
  }

  /** Path part for operation `apiOcppOperationSetMacAddressAndCarManufacturerPost()` */
  static readonly ApiOcppOperationSetMacAddressAndCarManufacturerPostPath = '/api/OcppOperation/SetMacAddressAndCarManufacturer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOcppOperationSetMacAddressAndCarManufacturerPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationSetMacAddressAndCarManufacturerPost$Response(params?: ApiOcppOperationSetMacAddressAndCarManufacturerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiOcppOperationSetMacAddressAndCarManufacturerPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOcppOperationSetMacAddressAndCarManufacturerPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOcppOperationSetMacAddressAndCarManufacturerPost(params?: ApiOcppOperationSetMacAddressAndCarManufacturerPost$Params, context?: HttpContext): Observable<void> {
    return this.apiOcppOperationSetMacAddressAndCarManufacturerPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
